import React from 'react';
import {cutLongStrings} from '../../components/helpers/helpers';
import {Tooltip} from 'material-ui';
import WebinarsGridActions from './WebinarsGridActions';

const webinarsGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        Header: 'Websites',
        accessor: 'sites',
        width: 200,
        Cell: (props) => {
            const sitesItems = props.value.map((item) => item.name).join(', ');
            return (
                <Tooltip title={sitesItems} style={{maxWidth: 400}}>
                    <span className="ellipsis">
                        {sitesItems.length > 1 ? sitesItems : '-'}
                    </span>
                </Tooltip>
            );
        },
    },
    {
        Header: 'Webinar Id',
        accessor: 'event_id',
        width: 200,
    },
    {
        Header: 'Event Title',
        accessor: 'event_title',
        Cell: (props) =>
            props.value === null ? (
                <span> - </span>
            ) : (
                <span
                    className="noMargin noPadding ellipsis"
                    dangerouslySetInnerHTML={{
                        __html: cutLongStrings(props.value),
                    }}
                />
            ),
    },
    {
        Header: 'When',
        accessor: 'start_date',
        width: 150,
    },
    {
        Header: 'Actions',
        width: 100,
        sortable: false,
        Cell: (props) => <WebinarsGridActions props={props} />,
    },
];

export default webinarsGridColumns;



// WEBPACK FOOTER //
// ./src/containers/webinars/WebinarsGridColumns.jsx